import React, {useState, createContext, useContext, useEffect} from 'react'
import Loading from 'components/loading'
import {fetchRest} from 'utils/asyncUtils'
import * as stringUtils from 'utils/stringUtils'
import {getOIDCUrl} from 'utils/envUtils'
import config from '../config'

const defaultAPI = {
  loginCase: 'default',
  lang: 'de',
  interactionToken: undefined,
}

export const InteractionContext = createContext(defaultAPI)
const InteractionContextProvider = InteractionContext.Provider
export const useInteractionContext = () => useContext(InteractionContext)

export const InteractionProvider = ({children}) => {
  const interactionUid = stringUtils.getInteractionUid(window.location.search)
  const [isLoading, setIsLoading] = useState(!!interactionUid)
  const [interactionData, setInteractionData] = useState(defaultAPI)

  useEffect(() => {
    const fetchInteractionDetails = async () => {
      try {
        // TODO: [Sentry] 404 very often
        const interactionUrl = `${getOIDCUrl()}/interaction/${interactionUid}/details`
        const interactionData = await fetchRest(interactionUrl, 'GET')
        interactionData.interactionToken = interactionData.token
        delete interactionData.token
        setInteractionData({...defaultAPI, ...interactionData})
      } catch (e) {
        window.location.assing = `${config.links.error}?custom_error_code=interaction_not_found`
      } finally {
        setIsLoading(false)
      }
    }

    if (interactionUid) {
      fetchInteractionDetails()
    }
  }, [interactionUid])

  return (
    <InteractionContextProvider value={interactionData}>
      {isLoading ? <Loading /> : children}
    </InteractionContextProvider>
  )
}
